import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useIdle } from "@uidotdev/usehooks"
import { useLessonsMessages } from "../lessons/stores/use-lessons-message"
import { useIdleDialog } from "../store/use-idle-dialog"

// Fix
export default function IdleDialog() {
  const [count, setCount] = useState(30)

  const { isOpen, closeDialog, openDialog } = useIdleDialog()
  const { clearState: clearLessonsMessagesState } = useLessonsMessages()

  const countdownIntervalRef = useRef<NodeJS.Timeout | null>(null)

  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isValidSession = !pathname.endsWith("notFound") && !pathname.endsWith("summary")
  const validMinutesOfInactivity = 5
  const minsToMs = validMinutesOfInactivity * 60 * 1000
  const isIdle = useIdle(minsToMs)

  useEffect(() => {
    if (count === 0) {
      handleOnFinishSession()
    }
  }, [count])

  useEffect(() => {
    if (isIdle) {
      openDialog()
    }
  }, [isIdle])

  useEffect(() => {
    if (isOpen) {
      countdownIntervalRef.current = setInterval(() => {
        setCount((prevCount) => (prevCount > 0 ? prevCount - 1 : 0))
      }, 1000)
    } else {
      setCount(30)
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current)
        countdownIntervalRef.current = null
      }
    }
  }, [isOpen])

  const handleOnContinueStudying = () => {
    closeDialog()
  }

  const handleOnFinishSession = () => {
    clearLessonsMessagesState()
    closeDialog()
    navigate("/study")
  }

  if (!isValidSession) {
    return null
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={closeDialog}>
      <AlertDialogContent className="max-w-lg">
        <div className="mx-auto flex size-28 items-center justify-center overflow-hidden">
          <img
            alt="Clock icon"
            src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/clock.png"
            className="size-full object-contain"
          />
        </div>
        <AlertDialogHeader className="mt-2 text-center">
          <AlertDialogTitle className="text-center text-2xl font-bold leading-[120%]">
            ¿Seguís ahí?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center text-sm leading-[143%] text-muted-foreground">
            <span className="block text-sm font-normal">Parece que te tomaste una pausa ☕</span>
            <span className="block text-sm font-normal">
              ¿Seguimos con el estudio o preferís terminar la sesión?
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-3 flex w-full !flex-col gap-6">
          <div className="flex w-full items-center justify-between gap-4">
            <AlertDialogAction
              asChild
              onClick={handleOnFinishSession}
              className="bg-neutral-200 text-black"
            >
              <Button type="button" className="w-full">
                Terminar sesión
              </Button>
            </AlertDialogAction>
            <AlertDialogCancel
              asChild
              onClick={handleOnContinueStudying}
              className="border-primary-500 bg-primary-500 hover:bg-primary-500 hover:text-white"
            >
              <Button type="button" className="w-full">
                Seguir estudiando
              </Button>
            </AlertDialogCancel>
          </div>
          <p className="text-center text-sm font-normal">
            Terminamos la sesión en <b>{count}s</b> si no respondés.
          </p>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
